import { TIME_DELAY_MAKE_CASHOUT } from 'astra-core/containers/BetsHistoryProvider'

export const TOASTIFY_CASHOUT_NOTIFICATION_TIMER =
  TIME_DELAY_MAKE_CASHOUT / 1000 - 1
